const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 63.4096,19.8915 c 5.5885,-8.6661 12.6661,-14.0635 24.8032,-14.0635 16.1007,0 29.1685,13.0677 29.1685,29.1685 0,14.6786 -7.812,28.4066 -16.3749,39.8239 -10.116,13.4879 -22.5987,25.761 -34.5099,37.6725 l -3.0869,3.0869 -3.0869,-3.0869 C 48.4115,100.5814 35.9289,88.3083 25.8129,74.8204 17.25,63.4031 9.438,49.6751 9.438,34.9965 c 0,-16.1008 13.0677,-29.1685 29.1685,-29.1685 12.1371,0 19.2146,5.3974 24.8031,14.0635 z",
    style: {
      fill: "#e30016",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.4096,28.7957 c 6.2008,-12.4016 12.4016,-18.6024 24.8032,-18.6024 13.6913,0 24.8032,11.1119 24.8032,24.8032 0,24.8032 -24.8032,49.6064 -49.6064,74.4096 -24.8032,-24.8032 -49.6064,-49.6064 -49.6064,-74.4096 0,-13.6913 11.1118,-24.8032 24.8032,-24.8032 12.4016,0 18.6024,6.2008 24.8032,18.6024 z",
    style: {
      fill: "none",
      stroke: "#1b1918",
      strokeWidth: 0.216
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 553.5465,143.2559 8.2499,-13.875 c 0,0 8.9065,17.9058 18.1877,18.4685 9.2812,0.5627 14.25,-9.5624 14.25,-9.5624 3.9527,-6.0188 7.4767,-22.2477 11.7403,-38.224 1.9253,-7.2139 3.7729,-15.5138 6.3607,-21.6624 5.1891,-12.3304 12.5064,-19.4513 23.4303,-15.8644 0,0 5.9998,2.6382 5.9063,11.2632 l -10.1362,2.7992 c 0,0 2.2329,-7.503 -5.2667,-6.8468 -7.4997,0.6562 -10.6935,7.0844 -13.5445,16.7786 -2.8511,9.6942 -8.2684,29.3196 -12.8685,45.5689 0,0 -4.5935,20.2473 -20.8122,21.7474 -16.2187,1.5001 -25.4971,-10.5908 -25.4971,-10.5908 z",
    style: {
      fill: "#1b1918",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 40.9201,71.1685 3.8463,-6.4689 c 0,0 4.1524,8.3482 8.4795,8.6105 4.3272,0.2623 6.6438,-4.4582 6.6438,-4.4582 1.8428,-2.8061 3.4858,-10.3725 5.4736,-17.821 0.8976,-3.3633 1.759,-7.2329 2.9655,-10.0996 2.4193,-5.7487 5.8308,-9.0687 10.9238,-7.3963 0,0 2.7972,1.23 2.7536,5.2511 l -4.7257,1.3051 c 0,0 1.041,-3.4981 -2.4555,-3.1922 -3.4965,0.306 -4.9855,3.3029 -6.3148,7.8226 -1.3292,4.5197 -3.8549,13.6696 -5.9996,21.2454 0,0 -2.1416,9.4398 -9.7032,10.1392 -7.5615,0.6994 -11.8873,-4.9377 -11.8873,-4.9377 z",
    style: {
      fill: "#f5c33d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 66.5343,75.4347 c -0.1493,-9.1615 8.0055,-23.8809 5.9949,-27.0566 -0.2461,-0.3886 -0.4218,-0.4765 -0.7995,-0.6931 4.9052,2.1083 -3.6668,19.9159 -3.5466,27.4986 z",
    style: {
      fill: "#f5c33d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 85.8991,51.202 c -11.6855,12.1172 -10.7746,8.7036 -26.6652,8.0584 -2.5122,-0.1021 -8.652,0.516 -5.5813,4.7481 0.3153,0.4345 0.7427,0.7934 1.2078,1.0568 -0.7043,-0.3267 -1.3593,-0.8797 -1.7298,-1.5697 -2.3012,-4.2849 3.3466,-5.0898 6.1144,-5.2028 15.7177,-0.6419 13.8808,3.7568 25.4192,-8.212 z",
    style: {
      fill: "#f5c33d",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.68b59e32ea5ce05801d34a215c99dfa7.svg";
export { ForwardRef as ReactComponent };